__turbopack_context__.v({
  "burger": "IconMenu-module-scss-module__kZ5SJW__burger",
  "open": "IconMenu-module-scss-module__kZ5SJW__open",
});
